import { School, SchoolUser } from "@core/models/domain/account.domain";
import { SyncIntegrationResponse } from "@core/models/response/account.response";

export interface AccountState {
  users: SchoolUser[];
  // Cache metadata: usersLoaded flips on the first successful load and back to false
  // on explicit invalidation (e.g. Wonde sync); usersLastLoadedAt drives the TTL check
  // in the loadUsersIfNeeded effect.
  usersLoaded: boolean;
  usersLastLoadedAt: number | null;
  schoolInfo: School;
  integrationSchoolSyncResult: SyncIntegrationResponse | null;
  /** True while a run is in progress server-side, whoever started it and wherever they are now. */
  integrationSchoolSyncLoading: boolean;
  integrationSchoolSyncError: string | null;
  /** When the running run started, so the page can say since when it has been going. */
  integrationSyncStartedDatetime: string | null;
  /** True while a sync mode change is being saved. */
  syncModeSaving: boolean;
  /** Why the last sync mode change was refused, shown under the mode select. */
  syncModeError: string | null;
  /** True while the school deactivation runs (DIGI-1855). */
  deactivatingSchool: boolean;
  /** Why the last deactivation was refused, shown in the deactivation section. */
  deactivateSchoolError: string | null;
  userLoading: boolean;
  userError: string;
  schoolLoading: boolean;
  schoolError: string;
}

export const initialAccountState: AccountState = {
  users: [],
  usersLoaded: false,
  usersLastLoadedAt: null,
  schoolInfo: undefined as School,
  integrationSchoolSyncResult: null,
  integrationSchoolSyncLoading: false,
  integrationSchoolSyncError: null,
  integrationSyncStartedDatetime: null,
  syncModeSaving: false,
  syncModeError: null,
  deactivatingSchool: false,
  deactivateSchoolError: null,
  userLoading: false,
  userError: null,
  schoolLoading: false,
  schoolError: null,
};
